/**
 * Portal
 * The ISC Portal is designed as an entrypoint for ISC to publish solutions to multiple cloud providers that are consumed by external users.  On this page, Swagger UI is already pre-authorised with your current JWT token and you can explore and try out APIs with your current user\'s credentials.  <code> !!! WARNING !!! Any command you issue from this page or using API calls will take an immediate effect on your deployments and data without any further confirmations. Please be very careful with POST and DELETE commands. </code>  If you want to use those APIs programmatically, you need to get JWT token first because it has a very limited expiration time.  There are multiple options to get JWT token from Amazon Cognito which our Cloud Portal use, the simplest one is to use curl and jq commands:  <code> TOKEN=$(curl -s \"https://cognito-idp.us-east-2.amazonaws.com/\" \\ -X POST \\ -d \'{\"AuthFlow\":\"USER_PASSWORD_AUTH\",\"ClientId\":\"5lif09dom0glg27o8ha6duu9bs\",\"AuthParameters\":{\"USERNAME\":\"<USERNAME>\",\"PASSWORD\":\"<PASSWORD>\"}}\' \\ -H \"content-type: application/x-amz-json-1.1\" \\ -H \"X-Amz-Target: AWSCognitoIdentityProviderService.InitiateAuth\" | jq -r \'.AuthenticationResult.IdToken\'  ) </code>  After you get the token, you can use it to authenticate with InterSystems Cloud Portal, for example:  <code> curl \'https://portal.live.isccloud.io/v3/api/deployments\' \\ -X \'GET\' \\ -H \'accept: application/json\' \\ -H \"Authorization: Bearer $TOKEN\" </code> 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: portal-dev@intersystems.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeploymentObjectResourceList } from './deploymentObjectResourceList';
import { DeploymentObjectVersionList } from './deploymentObjectVersionList';
import { DeploymentObjectInstanceStatusList } from './deploymentObjectInstanceStatusList';
import { DeploymentObjectStateList } from './deploymentObjectStateList';
import { CloudFormationListStackResources } from './cloudFormationListStackResources';
import { DeploymentConfiguration } from './deploymentConfiguration';


/**
 * The deployment object schema
 */
export interface DeploymentObject { 
    account?: string;
    bank_config?: boolean;
    iris_health?: boolean;
    configuration?: DeploymentConfiguration;
    created_at?: string;
    deleted_at?: string;
    ecp_config?: boolean;
    deploymentid?: string;
    deploymentname?: string;
    stackname?: string;
    ha_config?: DeploymentObject.HaConfigEnum;
    hosted_zone_id?: string;
    hosted_zone_name?: string;
    instance_status_list?: Array<DeploymentObjectInstanceStatusList>;
    is_commercial?: boolean;
    is_spot?: boolean;
    item_type?: string;
    mam_status?: boolean;
    offer_name?: boolean;
    owner_name?: string;
    region?: string;
    resource_role?: string;
    state_list?: DeploymentObjectStateList;
    storage_last_notify_date?: boolean;
    subscriptionid?: boolean;
    updated_at?: string;
    cloudprovider?: DeploymentObject.CloudproviderEnum;
    provisiontime?: string;
    deploymenttype?: string;
    deploymentsize?: string;
    status?: string;
    guid?: string;
    tenantid?: string;
    irisuser?: string;
    irispassword?: string;
    samip?: string;
    bastionip?: string;
    bastionkeydownload?: string;
    bastionsshcommand?: string;
    natip?: string;
    nlbhostname?: string;
    vpcid?: string;
    openvpnurl?: string;
    openvpnconnecturl?: string;
    grafanaurl?: string;
    prometheusurl?: string;
    prometheusurltargets?: string;
    irisprimaryinstanceid?: string;
    irisprimaryhostname?: string;
    irisprimaryurl?: string;
    irisprimaryjdbc?: string;
    irisprimaryjdbcdownload?: string;
    irisprimaryprometheusurl?: string;
    irisprimaryterminal?: string;
    irissecondaryinstanceid?: string;
    irissecondaryhostname?: string;
    irissecondaryurl?: string;
    irissecondaryjdbc?: string;
    irissecondaryjdbcdownload?: string;
    irissecondaryprometheusurl?: string;
    irissecondaryterminal?: string;
    irisarbeiterinstanceid?: string;
    irisarbeiterhostname?: string;
    irisarbeiterurl?: string;
    irisarbeiterjdbc?: string;
    irisarbeiterjdbcdownload?: string;
    irisarbeiterprometheusurl?: string;
    irisarbeiterterminal?: string;
    keydownload?: string;
    irisfhirendpoint?: string;
    service_level?: string;
    service_level_urgency?: string;
    service_status?: string | boolean;
    resources?: CloudFormationListStackResources;
    resource_list?: DeploymentObjectResourceList;
    version_list?: DeploymentObjectVersionList;
}
export namespace DeploymentObject {
    export type HaConfigEnum = 'mirrored' | 'non-mirrored';
    export const HaConfigEnum = {
        Mirrored: 'mirrored' as HaConfigEnum,
        NonMirrored: 'non-mirrored' as HaConfigEnum
    };
    export type CloudproviderEnum = 'aws';
    export const CloudproviderEnum = {
        Aws: 'aws' as CloudproviderEnum
    };
}


